import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = 'G-8L4T10CP2K';

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag) return;

        window.gtag('config', GA_TRACKING_ID, {
            page_path: location.pathname + location.search,
        });
    }, [location]);

    return null;
};

export default GoogleAnalytics;
